// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import resize from 'vue-resize-directive'
import * as echarts from "echarts" //引入echarts
Vue.prototype.$echarts = echarts


import SocketIO from "vue-socket.io";
import ClientSocketIO from "socket.io-client";

Vue.use(new SocketIO({debug: false,connection: ClientSocketIO.connect("http://localhost:8081", {transports: ["websocket"],autoConnect: false, }),})
)


// import websocket from '../../utils/webSocket';
// Vue.prototype.$websocket = websocket;



 import '@/utils/flexible'


Vue.config.productionTip = false
Vue.use(require('element-ui'))
Vue.use(VueRouter)
Vue.prototype.$utils = require('@/utils/utils.js')
Vue.prototype.$commons = require('@/utils/commons.js')



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})

export default {
    directives: {
        resize,
    }
}



// WEBPACK FOOTER //
// ./src/pages/index/index.js